import {
  FaThLarge,
  FaWallet,
  FaBuilding,
  FaDownload,
  FaUsersCog,
  FaLink,
  FaExternalLinkAlt,
  FaCode,
  FaChevronRight,
  FaChevronLeft,
  FaExpandArrowsAlt,
  FaSignOutAlt,
  FaSyncAlt,
} from "react-icons/fa";
import { IoMdSchool } from "react-icons/io";
import { Link, NavLink } from "react-router-dom";
import "./css/sidebar.css";
import { CloseOutlined } from "@ant-design/icons";
import "../common/css/style.css";
import toast from "react-hot-toast";
import { setAuthorization } from "../helpers/api_helper";

const Sidebar = ({
  isSidebarCollapsed,
  setIsSidebarCollapsed,
  setIsSidebarOpen,
}) => {
  const authUser = JSON.parse(sessionStorage.getItem("authUser"));
  const goBackToAdmin = () => {
    const adminData = localStorage.getItem("backupAdmin");

    if (adminData) {
      sessionStorage.setItem("authAdmin", adminData);
      localStorage.removeItem("backupAdmin");
      const adminToken = JSON.parse(adminData).token;
      // remettre le token admin dans AXIOS
      setAuthorization(adminToken, true);
    }
    sessionStorage.removeItem("authUser");

    window.location.href = "/dashboard-admin";
  };
  const kycVerified =
    authUser?.roles == "COLLABORATOR" ? true : authUser?.kycVerified;

  return (
    <aside className={`sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        {!isSidebarCollapsed ? (
          <img
            src="/img/paxity-logo-sidebar.png"
            alt="Logo"
            className="logo-Sidebar"
          />
        ) : (
          <img
            src="/img/logo-simplified.png"
            alt="Logo-Simplified"
            className="logo"
          />
        )}

        <button
          onClick={() => setIsSidebarOpen(false)}
          className="d-md-none drawer-button"
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#333")}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#000")}
        >
          <CloseOutlined style={{ color: "#fff", fontSize: "16px" }} />
        </button>

        <button
          className="d-none d-md-block collapse-btn"
          onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        >
          {isSidebarCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
      </div>

      <div className="sidebar-menu-container">
        {!kycVerified && (
          <div
            className="sidebar-disable-overlay"
            onClick={() =>
              toast.success("Merci de finaliser la vérification de votre KYC afin d’accéder à l’ensemble des fonctionnalités.")
            }
          />
        )}

        <nav className="sidebar-menu">
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""} ${isSidebarCollapsed ? "collapsed" : ""}`
            }
            data-tour-id="dashboard"
          >
            <FaThLarge />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">Tableau de bord</span>
            )}
          </NavLink>

          <NavLink
            to="/soldes"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""} ${isSidebarCollapsed ? "collapsed" : ""}`
            }
            data-tour-id="soldes"
          >
            <FaWallet />
            {!isSidebarCollapsed && <span className="font-sidebar">Solde</span>}
          </NavLink>

          <NavLink
            to="/business"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""} ${isSidebarCollapsed ? "collapsed" : ""}`
            }
            data-tour-id="business"
          >
            <FaBuilding />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">Business</span>
            )}
          </NavLink>

          <NavLink
            to="/versement"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""} ${isSidebarCollapsed ? "collapsed" : ""}`
            }
            data-tour-id="versement"
          >
            <FaDownload />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">Versements</span>
            )}
          </NavLink>

          <NavLink
            to="/school-fees"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""} ${isSidebarCollapsed ? "collapsed" : ""}`
            }
            data-tour-id="school-fees"
          >
            <IoMdSchool />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">EduPax</span>
            )}
          </NavLink>

          <div className="sidebar-separator" />

          <NavLink
            to="/payment-link"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""} ${isSidebarCollapsed ? "collapsed" : ""}`
            }
            data-tour-id="lien"
          >
            <FaExternalLinkAlt />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">Lien de paiement</span>
            )}
          </NavLink>

          <NavLink
            to="/collect-link"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""} ${isSidebarCollapsed ? "collapsed" : ""}`
            }
            data-tour-id="lien"
          >
            <FaExternalLinkAlt />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">Lien de collecte</span>
            )}
          </NavLink>

          <NavLink
            to="/payout-mass"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""}`
            }
            data-tour-id="mass"
          >
            <FaExpandArrowsAlt />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">Paiement en masse</span>
            )}
          </NavLink>

          {/* <NavLink
            to="/transfers"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""} ${isSidebarCollapsed ? "collapsed" : ""}`
            }
            data-tour-id="transfers"
          >
            <FaLink />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">Transfert d'argent</span>
            )}
          </NavLink> */}

          <NavLink
            to="/webhook"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""} ${isSidebarCollapsed ? "collapsed" : ""}`
            }
            data-tour-id="webhook"
          >
            <FaSyncAlt />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">Webhooks</span>
            )}
          </NavLink>

          <div className="sidebar-separator" />
          {/* <NavLink
            to="/roles"
            className={({ isActive }) =>
              `sidebar-item ${isActive ? "active" : ""} ${isSidebarCollapsed ? "collapsed" : ""}`
            }
            data-tour-id="roles"
          >
            <FaUsersCog />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">Gestion des roles</span>
            )}
          </NavLink> */}

          <a className="sidebar-item">
            <FaCode />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">Documentation</span>
            )}
          </a>
        </nav>
      </div>
      {/* Bouton retour à l’espace admin */}
      <div className="sidebar-footer">
        {localStorage.getItem("backupAdmin") && (
          <button
            className={`logout-btn   ${isSidebarCollapsed ? "collapsed" : ""}`}
            onClick={goBackToAdmin}
          >
            <FaChevronLeft />
            {!isSidebarCollapsed && (
              <span className="font-sidebar">Retour à l’espace admin</span>
            )}
          </button>
        )}
      </div>

      {/* --- FOOTER --- */}

      <div className="sidebar-footer">
        {!localStorage.getItem("backupAdmin") && (
          <Link to="/logout">
            <button className="logout-btn">
              <FaSignOutAlt />
              {!isSidebarCollapsed && (
                <span className="font-sidebar">Déconnexion</span>
              )}
            </button>
          </Link>
        )}
      </div>
    </aside>
  );
};
export default Sidebar;
